{
  "id": "campaign-004",
  "name": "Sleepy Spot",
  "seed": "campaign:4",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [".......", ".B...B.", ".......", "....#..", ".......", ".......", "S......"],
  "critters": [],
  "pickups": [
    {
      "kind": "coin",
      "x": 4,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 5
    },
    {
      "kind": "rare",
      "x": 6,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 4,
  "biome": "backyard",
  "par": {
    "reel": 1410,
    "push": 1274,
    "selfPropelled": 1176,
    "tractor": 1000,
    "zeroTurn": 799,
    "fairway": 528
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 9
    }
  }
}
